<template>
  <v-card tile>
    <v-card-title>Update tickets count</v-card-title>
    <v-card-text v-if="formData">
      <content-field
        v-model="formData.newTicketsCount"
        label="Tickets count"
        type="number"
        :error="$v.formData.newTicketsCount"
      />
    </v-card-text>
    <v-layout
      justify-center
      v-if="isShowMessageAndBtn"
    >
      <p :class="errorOrWarningClass">{{ errorOrWarningMessage }}</p>
    </v-layout>
    <v-layout>
      <v-card-actions v-if="!isWarning">
        <v-btn class="green white--text" @click="save">Update</v-btn>
      </v-card-actions>
      <v-card-actions v-if="isWarning">
        <v-btn class="green white--text" @click="updateAndSave">Update</v-btn>
      </v-card-actions>
      <v-card-actions v-if="isShowMessageAndBtn">
        <v-btn class="white" @click="close">Close</v-btn>
      </v-card-actions>
    </v-layout>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex'
  import ContentField from '@/components/shared/ContentField'
  import { required, numeric } from 'vuelidate/lib/validators'
  import { pathOr } from 'ramda'
  export default {
    name: 'EnableInvitationForm',
    components: {
      ContentField
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      params: {
        type: Object,
        default: () => ({itemsOnPage: 5})
      },
      isOpen: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      item (value) {
        this.formData = {...value, newTicketsCount: parseInt(value.ticketsCount) + 1}
      },
      isOpen (val) {
        if (!val) this.resetErrors ()
      }
    },
    validations () {
      return {
        formData: {
          id: { required },
          newTicketsCount: { required, numeric }
        }
      }
    },
    data () {
      return {
        formData: null,
        isMinValueErr: false,
        isWarning: false
      }
    },
    computed: {
      isShowMessageAndBtn () {
        return this.isMinValueErr || this.isWarning
      },
      errorOrWarningMessage () {
        return this.isMinValueErr ?
          'You can\'t set amount of tickets which is less than amount of already registered users!' :
          'Warning! You have set amount of tickets which is less than number of already paid tickets!'
      },
      errorOrWarningClass () {
        return {
          'error-message': this.isMinValueErr,
          'warning-message': this.isWarning
        }
      }
    },
    methods: {
      ...mapActions(['enableVipInvitationPackage', 'fetchVipInvitations', 'disableVipInvitationPackage']),
      resetErrors () {
        this.isMinValueErr = false
        this.isWarning = false
      },
      errorHandler (err) {
        const errorRes = pathOr([], ['data', 'ValidationFailures'], err.response)
        if (errorRes.length && errorRes.find((el) => el.errorCode === 'enable-vip-invitation-0002')) {
          this.isMinValueErr = true
        }
        throw err
      },
      close () {
        this.$emit('close')
      },
      closeOrShowWarningMessage (res) {
        res.status === 202 ? this.isWarning = true : this.close()
      },
      async updateAndSave () {
        try {
          await this.disableVipInvitationPackage({ id: this.formData.id })
          this.save()
        } catch (err) {
          console.error(err)
        }
      },
      async save () {
        this.$v.$touch()
        if (this.$v.formData.$invalid) return
        try {
          const response = await this.enableVipInvitationPackage(this.formData)
          this.closeOrShowWarningMessage(response)
          this.fetchVipInvitations(this.params)
        } catch(err) {
          this.errorHandler(err)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .error-message,
  .warning-message {
    text-align: center;
    padding: 0 20px;
  }

  .error-message {
    color: #ff5252;
  }

  .warning-message {
    color: #f7af32;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/VipInvitation/enableInvitationForm.vue